import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initErrorCapture } from "./lib/bugReportUtils";
import { GlobalErrorBoundary } from "./components/GlobalErrorBoundary";
import { clearStaleChunkGuard } from "./lib/lazyWithRetry";

// Start capturing JS errors for bug reports
initErrorCapture();

createRoot(document.getElementById("root")!).render(
  <GlobalErrorBoundary>
    <App />
  </GlobalErrorBoundary>
);

// The app booted on the current build — allow a future stale-chunk reload.
window.setTimeout(clearStaleChunkGuard, 5000);

